import { render, staticRenderFns } from "./SupportChat.vue?vue&type=template&id=a5c61376"
import script from "./SupportChat.vue?vue&type=script&lang=js"
export * from "./SupportChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports